export default __webpack_public_path__ + "static/media/boomingroar.8ab53fe6.png";